import get from 'lodash/get'
import { RaRecord, useTranslate } from 'react-admin'
import { FC } from 'react'

export const ToolbarTitle: FC<ToolbarTitleProps> = (props) => {
  const {
    className,
    i18n,
    record,
    source,
  } = props
  const translate = useTranslate()
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  const getSource = source ? get(record, source) as string : undefined

  if (i18n && getSource) {
    return <span className={className}>{translate(i18n, { name: getSource })}</span>
  } else if (getSource) {
    return <span className={className}>{getSource}</span>
  } else if (i18n) {
    return <span className={className}>{translate(i18n)}</span>
  } else {
    return null
  }
}

interface ToolbarTitleProps {
  className?: string | undefined;
  i18n?: string;
  record?: RaRecord;
  source?: string;
  [key: string]: any;
}
